import { Skeleton, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { ORDER_STATES } from 'constants/sorting-facility';

import CrumbsBar from '../CrumbsBar/CrumbsBar';

import { ReactComponent as TooltipIcon } from 'assets/bosta-icons/Tooltip.svg';
import { ReactComponent as Download } from 'assets/bosta-icons/Download.svg';

const CrumbsBarContainer = ({
  loading,
  data,
  exportTransferredFromHubsData,
  exportCardsData,
  selectedDate,
  initialSelectedDate,
  firstStep,
  secondStep,
  thirdStep,
  hideToolTips
}) => {
  const intl = useIntl();
  return (
    <>
      <CrumbsBar />
      <div className="sorting-facility__crumb-bar-data">
        <div>
          {loading ? (
            <Skeleton active paragraph={{ rows: 0 }} />
          ) : (
            <h4 className="display-xs">
              {data?.ready_to_dispatch_deliveries_count || 0}
              <span className="caption">
                {intl.formatMessage(
                  {
                    id: 'ops_control.dispatching.seals_number'
                  },
                  {
                    seals_number: data?.ready_to_dispatch_seals_count || 0
                  }
                )}
              </span>
              <span className="export-data-button">
                {!dayjs(selectedDate)?.isBefore(initialSelectedDate, 'day') && (
                  <Download
                    onClick={() =>
                      exportCardsData({
                        states: [ORDER_STATES.READY_TO_DISPATCH]
                      })
                    }
                  />
                )}
              </span>
            </h4>
          )}
          <h6>
            {firstStep ||
              intl.formatMessage({
                id: 'ops_control.dispatching.ready_to_dispatch'
              })}
            {!hideToolTips && (
              <Tooltip
                title={intl.formatMessage({
                  id: 'ops_control.sorting_facility.tooltips.ready_to_dispatch'
                })}
              >
                <TooltipIcon />
              </Tooltip>
            )}
          </h6>
        </div>
        <div>
          {loading ? (
            <Skeleton active paragraph={{ rows: 0 }} />
          ) : (
            <h4 className="display-xs">
              {data?.in_transit_deliveries_count || 0}
              <span className="caption">
                {intl.formatMessage(
                  {
                    id: 'ops_control.dispatching.seals_number'
                  },
                  {
                    seals_number: data?.in_transit_seals_count || 0
                  }
                )}
              </span>
              <span className="export-data-button">
                {!dayjs(selectedDate)?.isBefore(initialSelectedDate, 'day') && (
                  <Download
                    onClick={() =>
                      exportTransferredFromHubsData({ isDispatching: true })
                    }
                  />
                )}
              </span>
            </h4>
          )}
          <h6>
            {secondStep ||
              intl.formatMessage({
                id: 'ops_control.dispatching.dispatched'
              })}
            {!hideToolTips && (
              <Tooltip
                title={intl.formatMessage({
                  id: 'ops_control.sorting_facility.tooltips.dispatched'
                })}
              >
                <TooltipIcon />
              </Tooltip>
            )}
          </h6>
        </div>
        <div>
          {loading ? (
            <Skeleton active paragraph={{ rows: 0 }} />
          ) : (
            <h4 className="display-xs">
              {data?.completed_deliveries_count || 0}
              <span className="caption">
                {intl.formatMessage(
                  {
                    id: 'ops_control.dispatching.seals_number'
                  },
                  {
                    seals_number: data?.completed_seals_count || 0
                  }
                )}
              </span>
            </h4>
          )}
          <h6>
            {thirdStep ||
              intl.formatMessage({
                id: 'ops_control.dispatching.completed'
              })}
            {!hideToolTips && (
              <Tooltip
                title={intl.formatMessage({
                  id: 'ops_control.sorting_facility.tooltips.completed'
                })}
              >
                <TooltipIcon />
              </Tooltip>
            )}
          </h6>
        </div>
      </div>
    </>
  );
};

export default CrumbsBarContainer;
